import { Observable } from 'rxjs';
import { Locale } from '../models';

export abstract class IMeLocale {
    public abstract getMeLocale(): Locale | undefined;

    public abstract getMeLocale$(): Observable<Locale | undefined>;
}
